module.exports = require("core-js-pure/features/object/assign");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs3/core-js/object/assign.js
// module id = 485
// module chunks = 13